module.exports = "<div>\r\n  <carousel-banner ng-if=\"$ctrl.dbData.isCarousel\"\r\n       cb-items=\"$ctrl.dbData.items\"\r\n       cb-name=\"$ctrl.dbName\"></carousel-banner>\r\n  <div ng-if=\"!$ctrl.dbData.isCarousel\">\r\n    <a href=\"{{$ctrl.dbData.items[0].url ? $ctrl.dbData.items[0].url : '#'}}\"\r\n       title=\"{{$ctrl.dbData.items[0].title}}\">\r\n      <img ng-src=\"{{$ctrl.dbData.items[0].imageUrl}}\" class=\"img-responsive img-margin\">\r\n    </a>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/dynamic-banner/templates/dynamic-banner-base.view.html
 ** module id = 100
 ** module chunks = 0
 **/